import { CdnAsset } from "#components/ui/CdnAsset.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { IllustrationAssets } from "#types/assets.ts";
import { Flex, Heading, Text } from "@hopper-ui/components";

export const SavedMemoriesEmptyState = () => {
    const { tShared } = useSharedTranslation();

    return (
        <Flex
            direction="column"
            alignItems="center"
            justifyContent="center"
            padding="inset-lg"
        >
            <CdnAsset
                asset={IllustrationAssets.Brain}
                alt={tShared("personalization.savedMemoriesEmptyState.title")}
            />
            <Flex direction="column" gap="inline-sm" textAlign="center" paddingY="inset-md">
                <Heading>{tShared("personalization.savedMemoriesEmptyState.title")}</Heading>
                <Text UNSAFE_maxWidth="26rem">{tShared("personalization.savedMemoriesEmptyState.description")}</Text>
            </Flex>
        </Flex>
    );
};
